import { ApiUrl } from "../../../../assets/data/TkApiUrlProperty";
import http from "../../../../services/http";
import {
  IAPI_COM013_Request,
  IAPI_COM013_Response,
} from "../../../../type/apiType";

// 郵便番号検索
const httpGetPostalCode = async (
  param: IAPI_COM013_Request
): Promise<IAPI_COM013_Response> => {
  let res = await http.post(`${ApiUrl.API_COM013}`, {
    ...param,
  });

  return res.data;
};

export { httpGetPostalCode };
